import {Button, Flex} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCode, faFileLines, faReceipt, faSquare} from "@fortawesome/free-solid-svg-icons";
import React from "react";

import {DraftComponent, DraftElement, DraftElementItem} from "../../../../../../../../feature/Draft";

export const LoreItem = (
    props: {
        item: DraftElementItem,
        active?: boolean,
        onElementSelected?: (element: DraftElementItem) => void,
        showEmbeddingState?: boolean,
    }
) => {

    return (
        <Button
            key={props.item.id}
            style={{
                textAlign: 'start',
                height: "auto",
                background: props.active ? "#f0f0f0" : undefined,
                padding: '8px 8px 8px 16px'
            }}
            type={'text'}
            onClick={() => {
                props.onElementSelected?.(props.item)
            }}>
            <Flex
                style={{width: "100%"}}
                justify={'space-between'}
                gap={10}
                align={'center'}
            >

                <FontAwesomeIcon
                    style={{color: props.item.title && props.item.description && props.item.title.trim().length > 0 && props.item.description.trim().length > 0 ? "#0958d9" :props.item.title?.trim().length == 0 && props.item.description?.trim().length == 0 ? "#cccccc" : "#faad14"}}
                    icon={faReceipt}/>

                <div style={{
                    flexGrow: 1,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                }}>{props.item.title}</div>

                <span className="fa-layers fa-fw fa-lg" style={{display: props.showEmbeddingState ? 'block' : 'none'}}>
                        <FontAwesomeIcon icon={faSquare}
                                         color={props.item.embedded == true ? "#17813b" : props.item.embedded == false ? "#ccc" : "#faad14"}/>
                        <FontAwesomeIcon icon={faCode}
                                         className={"fa-inverse"}
                                         transform="shrink-8"/>
                    </span>
            </Flex>
        </Button>
    )
}